<div class="poll-wrapper" [class.detailed]="detailed">
  <div class="hold" [ngStyle]="holdTransform()"></div>
  <div class="against" [ngStyle]="againstTransform()"></div>
  <div class="for" [ngStyle]="forTransform()"></div>
</div>
<div *ngIf="detailed" class="details">
  <div class="voting-legend" [ngClass]="{ mobile: rwdService.isSmallDevice, portrait: rwdService.isPhonePortrait }">
    <span class="for-votes" *ngIf="getPercentage('yes') as percent">
      <div class="symbol symbol-for"></div>
      {{ 'vote.for' | loc }} {{ percent | lNumber: 'twoDec' }}%
    </span>
    <span class="against-votes" *ngIf="getPercentage('no') as percent">
      <div class="symbol symbol-against"></div>
      {{ 'vote.against' | loc }} {{ percent | lNumber: 'twoDec' }}%
    </span>
    <span class="hold-votes" *ngIf="getPercentage('hold') as percent">
      <div class="symbol symbol-hold"></div>
      {{ 'vote.hold' | loc }} {{ percent | lNumber: 'twoDec' }}%
    </span>
    <span class="missing-votes">
      <div class="symbol symbol-missing"></div>
      {{ 'vote.uncast' | loc }} {{ getMissingVotes() | lNumber: 'twoDec' }}%
    </span>
  </div>
</div>
